// Trilha de níveis do Método ACM e a comissão progressiva de cada nível.
//
// Não é um total acumulado de carreira: a contagem de vendas ACM/Mentoria reinicia todo mês, mas o NÍVEL fica.
// Para subir, o vendedor precisa vender mais do que no mês anterior; vendendo a mesma quantidade mantém o
// nível; vendendo menos, cai um nível. Cada nível tem uma comissão fixa.
//
// Fonte única: o ranking (GamifiedLeaderboard) e a folha de pagamento usam este arquivo.
// Sem import de Deno.

// AAAA-MM do mês seguinte (sem importar payroll.ts, que importa este arquivo)
const proximoMes = (mes: string): string => {
    const [a, m] = mes.split('-').map(Number);
    const idx = a * 12 + (m - 1) + 1;
    return `${Math.floor(idx / 12)}-${String((idx % 12) + 1).padStart(2, '0')}`;
};

export interface NivelAcm {
    name: string;
    icon: string;
    /** % de comissão do nível */
    commission: number;
}

export const NIVEIS_ACM: NivelAcm[] = [
    { name: 'White', icon: '⚪', commission: 2.0 },
    { name: 'Blue', icon: '🔵', commission: 2.3 },
    { name: 'Gold', icon: '🟡', commission: 2.5 },
    { name: 'Black', icon: '⚫', commission: 3.0 },
    { name: 'Platinum', icon: '💎', commission: 4.0 },
];

/** Venda do Método ACM ou Mentoria (as que contam para o nível). */
export function ehVendaAcm(nomeProduto?: string | null): boolean {
    const n = (nomeProduto || '').toLowerCase();
    return n.includes('acm') || n.includes('mentoria') || n.includes('método') || n.includes('metodo');
}

export function mesesEntre(inicio: string, fim: string): string[] {
    const meses: string[] = [];
    for (let m = inicio; m <= fim; m = proximoMes(m)) meses.push(m);
    return meses;
}

/**
 * Simula a trilha mês a mês, do primeiro mês com venda até `ateMes` (AAAA-MM): sobe, mantém ou desce um
 * nível por vez conforme a contagem de cada mês bate, empata ou fica abaixo da do mês anterior.
 */
export function calcularNivel(contagemPorMes: Record<string, number>, ateMes: string) {
    const comDados = Object.keys(contagemPorMes).sort();
    if (comDados.length === 0) return { levelIndex: 0, closedCount: 0, priorCount: 0 };

    const primeiro = comDados[0];
    const alvo = ateMes < primeiro ? primeiro : ateMes;
    const linha = mesesEntre(primeiro, alvo);

    let levelIndex = 0;
    let anterior = 0;
    let atual = 0;
    linha.forEach((m, i) => {
        atual = contagemPorMes[m] || 0;
        if (i > 0) {
            if (atual > anterior) levelIndex = Math.min(levelIndex + 1, NIVEIS_ACM.length - 1);
            else if (atual < anterior) levelIndex = Math.max(levelIndex - 1, 0);
        }
        anterior = atual;
    });

    const mesAnterior = linha.length > 1 ? linha[linha.length - 2] : null;
    return { levelIndex, closedCount: atual, priorCount: mesAnterior ? (contagemPorMes[mesAnterior] || 0) : 0 };
}
